<template>
  <div class="word-frame-container">
    <div v-if="$store.getters.xiGuaPlayer.wordData.sortList" class="header">
      <span class="font-bold">{{ $store.getters.xiGuaPlayer.wordData.word }}</span>
      在
      <span class="font-bold">【{{ $store.getters.xiGuaPlayer.wordData.materialName }}】</span>
      素材一共出现
      <span class="font-bold">{{ $store.getters.xiGuaPlayer.wordData.sortList.length }}</span>
      次，以下为出现位置
    </div>
    <div v-if="$store.getters.xiGuaPlayer.wordData" class="tag-content">
      <div
        v-for="item in $store.getters.xiGuaPlayer.wordData.sortList"
        :key="item.text"
        class="tag-item"
        :class="{ selected: selected === item.text }"
        @click="handleClickItem(item)"
      >
        <span>{{ item.text }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WordFrame',
  data() {
    return {
      selected: ''
    }
  },
  watch: {
    '$store.getters.xiGuaPlayer.wordData': function(wordData) {
      this.selected = wordData.selectedMarkText
    }
  },
  mounted() {
    this.selected = this.$store.getters.xiGuaPlayer.wordData.selectedMarkText
  },
  methods: {
    handleClickItem(item) {
      this.selected = item.text
      const { time } = item
      this.$store.dispatch('xiGuaPlayer/jump', { time })
    }
  }
}
</script>

<style lang="scss">
.word-frame-container {
  .header {
    text-align: left;
    color: #666;
    font-size: 12px;
  }
  .font-bold {
    color: #000;
    font-weight: 600;
    font-size: 14px;
  }
  .tag-content {
    display: flex;
    flex-wrap: wrap;
    margin-top: 12px;

    .tag-item {
      margin-right: 12px;
      margin-bottom: 12px;
      min-width: 140px;
      line-height: 32px;
      text-align: center;
      color: #02a7f0;
      cursor: pointer;
      border-radius: 16px;
      border: 1px solid #ccc;
      &.selected {
        color: #fff;
        background-color: #02a7f0;
        border-color: #02a7f0;
      }
    }
  }
}
</style>
